<template>
  <div>
    <CommonWords :messageType="0"></CommonWords>
  </div>
</template>

<script>
  import CommonWords from '@/views/IM/model/commonWords'

  export default {
    name: 'commonPhrases',
    components: { CommonWords },
  }
</script>
